module.exports = __webpack_public_path__ + "static/media/img112.b824a3ac.jpg";